module.exports = __webpack_public_path__ + "static/media/icon-iphone.86825c8e.svg";